import { TourPage } from '@/app/pages/tour-page/tour-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const tourPageSearchSchema = z.object({
  period: z.number(),
  cityId: z.string().optional(),
});

export const Route = createFileRoute('/tour/$tourId')({
  validateSearch: tourPageSearchSchema,
  component: TourPage,
});
